import { render, staticRenderFns } from "./OrdersFD.vue?vue&type=template&id=1a0ccd3e"
import script from "./OrdersFD.vue?vue&type=script&lang=js"
export * from "./OrdersFD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports